export default __webpack_public_path__ + "static/media/Royal_Bengal_Tiger_Kanha-1024x669.a3f161a8.jpg";